<template>
<li>
    <div class="title"><span>掛け率</span></div>
    <div class="detail">
        <p><span>n％ 〜 n％</span></p>
    </div>
</li>
</template>